import React, { Fragment } from "react";

const Regimenes = ({ regimenes = [], habitacion, idProducto, onRegimenSeleccionadoClick }) => {

  if (regimenes.length === 0) return <Fragment></Fragment>;
  //const [state, dispatch] = useContext(CdrGlobalContext);
  const { regimenSeleccionado = {}, idHabitacion } = habitacion || {};

  return (
    <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
          <h4>
            <i
              className="material-icons iconos-pagos"
              title="Regimen"
            >
              restaurant
            </i>{" "}
            elija el régimen
          </h4>
          <ul className="row">
            {regimenes.map((regimen) => {
              return (
                <li
                  className="liPuntosDeEmbarque"
                  style={{boxShadow: 'none'}}
                  key={regimen.codigo}
                >
                  <input
                    className="radioPuntoEmbarque"
                    type="radio"
                    name={`regimen${idHabitacion}`}
                    onChange={() => onRegimenSeleccionadoClick(idProducto, idHabitacion, regimen)}
                    value={regimen.codigo}
                    checked={regimenSeleccionado.codigo === regimen.codigo}
                  />
                  <label style={{marginRight: '15px'}}>{regimen.denominacion} {regimen.precio === '0.00' ? '(incluido)' : `$ ${regimen.precio}`}</label>
                </li>
              );
            })}
          </ul>
        </section>
  );
};

export default Regimenes;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/ProductoCuadro/regimenes.js